import { ReactNode } from "react";
import { imgPcMacbook } from "@/shared/assets/img";

type Props = {
  children: ReactNode;
};

export default function PcWrapper({ children }: Props) {
  return (
    <div
      id="pc"
      className="relative flex justify-center w-[80rem] h-[48.625rem] m-auto pt-1.75 rounded-tl-4 rounded-tr-4 overflow-hidden"
      style={{
        backgroundImage: `url(${imgPcMacbook})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
    >
      {children}
    </div>
  );
}
